import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemUsage } from '../../../entities/ItemUsage';
import { RequisitionLine } from '../../../entities/RequisitionLine';
import { MaintenanceObjectListConfig } from '../../../entities/enums/MaintenanceObjectListConfig';
import { MaintenanceObject } from 'app/entities/MaintenanceObject';

@Component({
  selector: 'app-modal-item-order',
  templateUrl: './modal-item-order.component.html',
  styleUrls: ['./modal-item-order.component.css']
})
export class ModalItemOrderComponent implements OnInit {


  public maintenanceObject: any;
  public _itemOrderToCreate: RequisitionLine = { Quantity: 0, Type: 'Item' };
  public _maintenanceObjectParent: any;
  public listOfPendingMaintenanceObjects: MaintenanceObject[] = [];
  public isQuantityValid = true;
  public _errorMessage: string;
  _maintenanceObjectConfiguration = MaintenanceObjectListConfig;

  @Output()
  createItemOrderEmitter = new EventEmitter()

  @Output()
  selectedConfigurationChange = new EventEmitter();

  @Output()
  oldAndNewMOEmitter = new EventEmitter<{oldMO: MaintenanceObject, newMO: MaintenanceObject}>()

  @Output()
  ListOfPendingMaintenanceObjectsChange = new EventEmitter<MaintenanceObject[]>()
  
  @Input()
  set MaintenanceObjectPreSelected(result: any) {
    if (result != null) {
      this._maintenanceObjectParent = result;
    }
  }


  @Input()
  selectedConfiguration;

  @Input()
  showErrorMessage: boolean;

  @Input()
  set errorMessage(result: string) {
    if (result != null)
      this._errorMessage = result;
  }

  constructor() { }

  ngOnInit() {
  }

  /**
   * Combines a generic ItemOrder with information from given item.
   * @param object - given ItemOrder
   * @returns ItemOrder with new informations.
   */
  setMaintenanceObject(object: any): any {
    if (object != null) {
      let localOrderItem = this._itemOrderToCreate;
      this.maintenanceObject = object;
      localOrderItem.Quantity = object.Quantity;
      localOrderItem.Registered_Date_Time = new Date();
      localOrderItem.No = object.Item_No;
      return localOrderItem;
    }
    return null;
  }

  /**
   * Creates a ItemOrder for every item in the pendingList (basket)
   */
  createItemOrder() {
    let localOrderItems: RequisitionLine[] = [];
    let localOrderItem: RequisitionLine = {};

    this.listOfPendingMaintenanceObjects.forEach(o => {
      localOrderItem = Object.assign({}, this.setMaintenanceObject(o));
      if (localOrderItem)
        localOrderItems.push(localOrderItem);
    });

    if (localOrderItems) {
      this.createItemOrderEmitter.emit(localOrderItems);
    }
  }

  /**
   * Changes view to pendingList (basket)
   * Emits value of new configuration, so buttons like 'Tilbage' can be swapped
   */
  goToPendingList() {
    this.selectedConfiguration = this._maintenanceObjectConfiguration.PendingList;
    this.selectedConfigurationChange.emit(this.selectedConfiguration);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-item-order/modal-item-order.component.ts